export let NotificationListenerEvent = /*#__PURE__*/function (NotificationListenerEvent) {
  /**
   * Invoked when the notification clicked.
   */
  NotificationListenerEvent["NOTIFICATION_CLICKED"] = "EVENT_NOTIFICATION_CLICKED";
  return NotificationListenerEvent;
}({});
//# sourceMappingURL=Listener.js.map